import React from "react";
import { SkuCounterContents } from "@deliverr/ui-facility";
import { BoxAuditEmptyContents } from "crossdock/common/components/BoxAuditContents";
import { MAX_UNITS_PER_PACKAGE } from "crossdock/common/maxUnitsPerPackage";
import { useBoxAuditBoxContents } from "./useBoxAuditBoxContents";

export const BoxAuditBoxContentsCard: React.FC = () => {
  const { boxContents, loading, onBoxContentsQtyChange } = useBoxAuditBoxContents();

  return (
    <SkuCounterContents
      emptyState={<BoxAuditEmptyContents />}
      isLoading={loading}
      items={boxContents}
      maxUnitsPerPackage={MAX_UNITS_PER_PACKAGE}
      onChange={onBoxContentsQtyChange}
    />
  );
};
